import App from "../App";

export default (store, queryClient) => {
  const domContainer = document.getElementById("js-login-page");
  if (domContainer) {
    import("./LoginContainer")
      .then(({ default: LoginContainer }) => {
        const root = ReactDOMClient.createRoot(domContainer);
        root.render(
          <App store={store} queryClient={queryClient}>
            <LoginContainer />
          </App>
        );
      })
      .catch(
        (error) => "An error occurred while loading the LoginForm component"
      );
  }
};
